import React, { useState } from "react";

const Tabs = ({
	tabs, className,
	tabClassName = "tab-title border-[#E7EFEF]", activeClassName = "!border-[#828282]",
	contentClassName, initialTab = 0, activeTab = null, setActiveTab = null
}) => {
	const [active, setActive] = useState(initialTab);

	const changeTab = (tab, index) => {
		if (tab?.onClick) {
			tab?.onClick();
			return;
		}
		if (setActiveTab) {
			setActiveTab(index);
			return;
		} 

		setActive(index);
	};

	if (!tabs?.length) return null;

	return (
		<>
			<div className={`${className ?? ""} flex m-auto md:justify-center items-center gap-5`}>
				{tabs.map((tab, index) => (
					<button
						className={`${tab?.style ?? ""} ${tabClassName} ${(activeTab ?? active) === index ? activeClassName : ""}`}
						key={index}
						onClick={() => changeTab(tab, index)}
					>
						{tab.label}
					</button>
				))}
			</div>
			<div className={contentClassName ?? ""}>
				{tabs[activeTab ?? active].content}
			</div>
		</>
	);
};

export default Tabs;
